import { gql } from '@apollo/client';

export const LIST_PIECES = gql`
  query ListPieces(
    $month_to: String!
    $month_from: String!
    $grouped: String
    $account_manager_campaigns: Boolean
    $has_publication_date: Boolean
    $campaign_name: String
    $client: [String]
    $influencers: [String]
    $status: [String]
    $offset: Int
    $limit: Int
  ) {
    listPieces(
      month_to: $month_to
      month_from: $month_from
      grouped: $grouped
      account_manager_campaigns: $account_manager_campaigns
      has_publication_date: $has_publication_date
      campaign_name: $campaign_name
      client: $client
      status: $status
      influencers: $influencers
      offset: $offset
      limit: $limit
    ) {
      status
      code
      error
      count
      data {
        user_name
        campaign_name
        platform
        type
        publication_date
        status
        campaign_id
        influencer_id
        profile_picture
        campaign_month
      }
      grouped_data {
        id
        name
        count
        pieces {
          user_name
          campaign_name
          platform
          type
          publication_date
          status
          campaign_id
          influencer_id
          profile_picture
          campaign_month
        }
      }
    }
  }
`;

export const LIST_MORE_PIECES_GROUPED = gql`
  query ListMorePiecesGrouped(
    $grouped_id: String!
    $month_to: String!
    $month_from: String!
    $grouped: String
    $account_manager_campaigns: Boolean
    $has_publication_date: Boolean
    $campaign_name: String
    $client: [String]
    $influencers: [String]
    $status: [String]
    $offset: Int
    $limit: Int
  ) {
    listMorePiecesGrouped(
      grouped_id: $grouped_id
      month_to: $month_to
      month_from: $month_from
      grouped: $grouped
      account_manager_campaigns: $account_manager_campaigns
      has_publication_date: $has_publication_date
      campaign_name: $campaign_name
      client: $client
      status: $status
      influencers: $influencers
      offset: $offset
      limit: $limit
    ) {
      status
      code
      error
      data {
        user_name
        campaign_name
        platform
        type
        publication_date
        status
        campaign_id
        influencer_id
        profile_picture
        campaign_month
      }
    }
  }
`;

export const LIST_CAMPAIGN_PIECES = gql`
  query ListCampaignPieces($campaign_id: String!) {
    listCampaignPieces(campaign_id: $campaign_id) {
      status
      code
      error
      data {
        piece_id
        user_name
        campaign_name
        platform
        type
        publication_date
        status
        campaign_id
        influencer_id
        profile_picture
        campaign_month
      }
    }
  }
`;
